<template>
  <g>
    <!-- NOTE: にぎやか度のバリエーション -->
    <sound-volum1 />
    <sound-volum2 />
    <sound-volum3 />
    <sound-volum4 />
    <sound-volum5 />
    <sound-volum6 />
  </g>
</template>

<script>
import soundVolum1 from './sound/volume1.vue';
import soundVolum2 from './sound/volume2.vue';
import soundVolum3 from './sound/volume3.vue';
import soundVolum4 from './sound/volume4.vue';
import soundVolum5 from './sound/volume5.vue';
import soundVolum6 from './sound/volume6.vue';

export default {
  components: {
    soundVolum1,
    soundVolum2,
    soundVolum3,
    soundVolum4,
    soundVolum5,
    soundVolum6,
  },
};
</script>



// WEBPACK FOOTER //
// sound.vue?5f865f9e